<template>
  <input-wrapper
    :error="error"
    :helperText="helperText"
    :disabled="disabled"
    :class="Object.assign({'text-input': 1}, classList)">

    <input
      v-model="currentValue"
      :id="id"
      autocomplete="off"
      :type="type"
      @focus="focus"
      :disabled="disabled"
      @keydown="emitKeys"
      @keyup="emitKeys"
      :class="{'disabled': disabled}"
      @blur="blur">

    <input-label :isRequired="isRequired" :for-id="id">{{placeholder}}</input-label>

    <button
      v-if="this.button"
      type="button"
      @click="buttonClicked">
      <sprite :name="this.button.name"></sprite>
    </button>

  </input-wrapper>
</template>

<script>
  import Sprite from '../Sprite.vue'
  import InputWrapper from '../../../components/ui/inputs/InputWrapper'
  import InputLabel from '../../../components/ui/inputs/InputLabel.vue'
  import input from '../../../mixins/input'

  export default {
    name: 'text_input',

    mixins: [input],

    props: {
      type: {
        type: String,
        default: 'text'
      },

      button: {
        type: Object
      },

      disabled: {
        type: Boolean,
        default: false
      },

      isRequired: {
        type: Boolean,
        default: false
      }
    },

    components: {
      InputWrapper,
      InputLabel,
      Sprite
    },

    methods: {
      buttonClicked() {
        this.$emit('submit', this.value)
      },
      emitKeys(event) {
        this.$emit(event.type, event)
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/base/form'
  @import '../../../styles/helpers/mixins'

  .text-input
    background-color: transparent

    input
      background: none
      display: inline-block
      border: none
      width: 100%
      top: 20px
      height: 46px
      flex: 1
      font-size: $font-size-input
      color: $color-text

      &:focus
        outline: none
      
      &.disabled
        cursor: not-allowed

    button
      padding: 10px
      background: none
      border: none
      cursor: pointer
      margin-right: -10px

      &:focus
        outline: 0

    .sprite
      width: 16px
      height: 16px
      transition: fill $transition-duration $transition-easing
      fill: $color-icon-disabled

    &.has-value
      input
        box-shadow: none

    &.has-focus
      input
        border-color: $color-text

  .text-input.is-invalid.has-focus
    .input-label
      color: $color-error

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/TextInput.vue